document.addEventListener("DOMContentLoaded", function() {
  const openButtons = document.querySelectorAll(".open-popup");
  const closeButtons = document.querySelectorAll(".close-popup");
  const popup = document.querySelector(".popup-wrap");

  // When clicking .open-popup → add 'active' to popup and hide scroll
  openButtons.forEach(button => {
    button.addEventListener("click", () => {
      if (popup) {
        popup.classList.add("active");
        document.documentElement.style.overflow = "hidden"; // disable scroll
      }
    });
  });

  // When clicking .close-popup → remove 'active' and restore scroll
  closeButtons.forEach(button => {
    button.addEventListener("click", () => {
      const popupWrap = button.closest(".popup-wrap");
      if (popupWrap) {
        popupWrap.classList.remove("active");
        document.documentElement.style.overflow = ""; // restore scroll
      }
    });
  });

  // When clicking outside .popup-inner-wrap → close popup
  if (popup) {
    popup.addEventListener("click", function(e) {
      const inner = popup.querySelector(".popup-inner-wrap");
      if (inner && !inner.contains(e.target)) {
        popup.classList.remove("active");
        document.documentElement.style.overflow = ""; // restore scroll
      }
    });
  }
});
